import React from "react";
import { buscarGRUsAtivas } from "../gru/actions/GRUActions";
import { View, Divider } from "react-template";
import {
  FormBoxConteiner,
  GRUBox
} from "../../components/formbuilder/FormBoxConteiner";

class IndexGRUs extends View {
  constructor(props) {
    super(props);
    this.state = { formList: [], gruList: [] };
  }

  componentDidMount() {
    buscarGRUsAtivas(
      res => {
        this.setState({ gruList: res.data.content });
      },
      error => {
        this.notifyError("Erro", "Erro ao buscar GRUs");
      }
    );
  }

  redirectToGRU(id) {
    this.redirect("/responderGRU/" + id);
  }

  getGRUBoxData(gru) {
    const titulo = JSON.parse(gru.formEditavel).titulo;
    const descricao = JSON.parse(gru.formEditavel).descricao;
    return {
      id: gru.id,
      titulo: titulo,
      descricao: descricao
    };
  }

  renderGRUBox(gru) {
    const gruItem = this.getGRUBoxData(gru);
    return (
      <GRUBox
        titulo={gruItem.titulo}
        descricao={gruItem.descricao}
        url={`/responderGRU/${gruItem.id}`}
      />
    );
  }
  render() {
    return (
      <div id="index-grus">
        <div>
          <Divider>GRUs Disponiveis</Divider>
        </div>
        <FormBoxConteiner>
          {this.state.gruList.map(gru => this.renderGRUBox(gru))}
        </FormBoxConteiner>
      </div>
    );
  }
}

export default IndexGRUs;



// WEBPACK FOOTER //
// ./src/view/inicio/GRUs.js